import type { ComponentType } from 'react';

import type { PresetSlug } from '../../profile/presets.ts';
import { Bear } from './Bear';
import { Cat } from './Cat';
import { Fox } from './Fox';
import { Frog } from './Frog';
import { Owl } from './Owl';
import { Panda } from './Panda';
import type { PresetArtProps } from './PresetFrame';
import { Penguin } from './Penguin';
import { Rabbit } from './Rabbit';
import { Robot } from './Robot';
import { Rocket } from './Rocket';
import { Star } from './Star';
import { Whale } from './Whale';

export type { PresetArtProps } from './PresetFrame';

/** A `Record`, so a slug added to `PRESET_SLUGS` without art fails `tsc`. */
export const PRESET_ART: Record<PresetSlug, ComponentType<PresetArtProps>> = {
  fox: Fox,
  owl: Owl,
  cat: Cat,
  bear: Bear,
  panda: Panda,
  rabbit: Rabbit,
  penguin: Penguin,
  frog: Frog,
  whale: Whale,
  rocket: Rocket,
  star: Star,
  robot: Robot,
};
